import { bridgeRequest } from "./bridgeRequest";

/**
 * 业务请求层。
 *
 * **请求由 Dmex 客户端代发**（见 utils/bridgeRequest.ts），本模块只保留调用形状：
 * 返回的仍是一层信封 `{ code, message, data, success? }`，与改造前一致，
 * 所以 20 个调用点都不用改。
 *
 * 改动前这里是一个 axios 实例，自己带 `Authorization: sessionStorage.tolink_token`
 * 与设备头。现在这些都不需要了：
 *  · 凭据由客户端持有并附加，页面里没有任何 token；
 *  · 设备头由客户端从 `yc:request_headers` 取（与页面无关）。
 *
 * **会话失效也不再在这里处理**：402 由客户端识别并接管（清会话、回登录页）。
 * 页面既不知道 dmex 的登录态，也没有"重新绑定"的能力 —— 原先那套
 * checkBind + 弹「加入工作组」卡片的逻辑随之删除。
 */

/**
 * 发一次请求，把桥的响应收敛成信封。
 *
 * 桥在传输层失败时 reject，这里让它原样抛给调用方 —— 改造前 axios 在网络错误时
 * 也是 reject，调用点那些 `.catch()` 的语义保持不变。
 */
async function call(options) {
  const res = await bridgeRequest(options);
  return res && res.data ? res.data : {};
}

/** GET 便捷封装 */
export function get(path, params) {
  return call({ path, method: "get", params });
}

/** POST 便捷封装 */
export function post(path, data) {
  return call({ path, method: "post", data });
}

/**
 * 默认导出保持**可调用**，因为绝大多数调用点是 `request({ url, method, data })`
 * 这种写法（20 处）；同时挂上 get/post 以兼容 `request.get(...)` 的写法。
 * 改造前它是个 axios 实例（既能 `request(config)` 也能 `request.get(...)`），
 * 这里对齐同一形状，调用点才不用改。
 */
function request(options) {
  return call({
    path: options.url,
    method: options.method,
    params: options.params,
    data: options.data,
  });
}

request.get = get;
request.post = post;

export default request;
